/* globals Audio */

define([
  'react',
  'prop-types',
  'immutable',
  'es6!sumo/util',
], (React, PropTypes, Immutable, Util) => {
  class SlotMachine extends React.Component {
    static propTypes = {
      api: PropTypes.object.isRequired,
      options: PropTypes.instanceOf(Immutable.List).isRequired,
      style: PropTypes.instanceOf(Immutable.Map).isRequired,
      winningOption: PropTypes.instanceOf(Immutable.Map).isRequired,
      onFinishGameAnimation: PropTypes.func.isRequired,
      isPreview: PropTypes.bool.isRequired,
      currentStep: PropTypes.string.isRequired,
      muteAudio: PropTypes.bool.isRequired,
    };

    constructor(props) {
      super(props);

      this.slots = [];
      this.initialPositions = [];

      if (props.api) {
        this.startSound = new Audio(`${props.api.properties.sumoUrl}/wav/game/slot-machine/start.wav`);
        this.winSound = new Audio(`${props.api.properties.sumoUrl}/wav/game/slot-machine/win.wav`);
        this.spinSound = new Audio(`${props.api.properties.sumoUrl}/wav/game/slot-machine/spin.wav`);
        this.loseSound = new Audio(`${props.api.properties.sumoUrl}/wav/game/slot-machine/lose.wav`);
      }
    }

    componentDidMount() {
      const { currentStep, winningOption } = this.props;
      const filteredOptions = this.props.options.filter(option => !!option.get('prizeType'));
      const degreesPerOption = 360 / filteredOptions.size;

      if (currentStep === 'subscribe' || !winningOption || !winningOption.get('prizeType')) {
        // Start slots in random locations
        this.slots.forEach((slot) => {
          const rotate = Math.floor(Math.random() * filteredOptions.size) * degreesPerOption;
          this.initialPositions.push(rotate);
          slot.style.transform = `rotateX(${rotate}deg)`;
        });
      } else if (winningOption) {
        // Start slots in result state
        this.slots.forEach((slot) => {
          slot.style.transform = `rotateX(-${(winningOption.get('index') * degreesPerOption)}deg)`;
        });
      }
    }

    componentDidUpdate() {
      const {
        isPreview,
        winningOption,
        onFinishGameAnimation,
        currentStep,
        muteAudio,
      } = this.props;

      if (winningOption && !this.isAnimating && currentStep === 'subscribe') {
        this.isAnimating = true;

        if (!isPreview && !muteAudio) {
          this.startSound.play();
          this.spinSound.play();
        }

        const filteredOptions = this.props.options.filter(option => !!option.get('prizeType'));
        const count = filteredOptions.size;
        const degreesPerOption = 360 / count;

        // Pregenerate losing results (so we don't accidentally win)
        const results = [];
        if (!winningOption.get('prizeType')) {
          for (let i = 0; i < Math.min(3, count); i += 1) {
            let index;
            do {
              index = Math.floor(Math.random() * count);
            } while (results.indexOf(index) > -1);

            results.push(index);
          }
        }

        this.slots.forEach((slot, i) => {
          if (!slot) return;
          // Reset slots to initial position
          slot.style.transition = '';
          slot.style.transform = `rotateX(${this.initialPositions[i]}deg)`;

          setTimeout(() => {
            slot.style.transition = `${(800 * i) + 2100}ms linear`;

            if (!winningOption.get('prizeType')) {
              // Stop on random losing pattern
              slot.style.transform = `rotateX(-${(results[i] * degreesPerOption) + 720}deg)`;
            } else {
              slot.style.transform = `rotateX(-${(winningOption.get('index') * degreesPerOption) + ((i + 1) * 360)}deg)`;
            }
          });
        });

        setTimeout(() => { this.spinSound.pause(); }, 4500);

        setTimeout(() => {
          if (!isPreview && !muteAudio) {
            if (winningOption.get('prizeType')) {
              this.winSound.play();
            } else {
              this.loseSound.play();
            }
          }

          this.isAnimating = false;
          if (onFinishGameAnimation) onFinishGameAnimation();
        }, 6e3);
      }
    }

    render() {
      const { api, style } = this.props;

      const filteredOptions = this.props.options.filter(option => !!option.get('prizeType'));
      const count = filteredOptions.size;
      const height = parseInt(style.get('height'), 10) || 240;
      const slotHeight = height - 100;
      const circumference = slotHeight * count;
      const radius = circumference / (2 * Math.PI);
      const degreesPerOption = 360 / count;

      const options = filteredOptions.map((option, index) => {
        const key = index;
        const rotate = index * degreesPerOption;
        const src = Util.getMediaUrl(api, option.get('mediaId'));
        const itemStyle = {
          transform: `rotateX(${rotate}deg) translateZ(${radius}px)`,
          backgroundColor: style.get('backgroundColor'),
        };

        return (
          <div
            key={key}
            style={itemStyle}
            className="sumome-react-wysiwyg-slot-item"
          >
            <img src={src} alt={option.get('label')} />
          </div>
        );
      });

      const slotStyle = {
        height: `${slotHeight}px`,
      };

      return (
        <div style={{ backgroundColor: style.get('backgroundColor') }} className="sumome-react-wysiwyg-slot-machine">
          <div style={{ height: `${height}px` }} className="sumome-react-wysiwyg-slots">
            <div
              style={slotStyle}
              ref={(el) => { this.slots[0] = el; }}
              className="sumome-react-wysiwyg-slot"
            >
              {options}
            </div>
            <div
              style={slotStyle}
              ref={(el) => { this.slots[1] = el; }}
              className="sumome-react-wysiwyg-slot"
            >
              {options}
            </div>
            <div
              style={slotStyle}
              ref={(el) => { this.slots[2] = el; }}
              className="sumome-react-wysiwyg-slot"
            >
              {options}
            </div>
          </div>
        </div>
      );
    }
  }

  return SlotMachine;
});
